import React from 'react'
import {connect} from 'react-redux'
import {update_config, load_pulls} from '../state/action_creators'
import {is_config_complete} from '../util'

class Config extends React.Component {
  constructor(props) {
    super(props)
    const {auth_token, owner, repo} = this.props.config
    this.state = {auth_token, owner, repo}
  }

  handle_change = (event) => {
    const {name, value} = event.target
    this.setState({[name]: value})
  }

  update_config() {
    this.props.update_config(this.state)
    this.props.load_pulls(this.state)
  }

  render() {
    const {auth_token, owner, repo} = this.state
    return (
      <div className="config">
        <div className="input-group">
          <b>Login</b>
          <div>
            <a href="https://github.com/settings/tokens" target="_blank" rel="noopener noreferrer">GitHub Personal Access Token:</a>
            <input type="password" name="auth_token" value={auth_token} onChange={this.handle_change} />
          </div>
        </div>
        <div className="input-group">
          <b>Repository</b>
          <div>Owner: <input type="text" name="owner" value={owner} onChange={this.handle_change} /></div>
          <div>Repo: <input type="text" name="repo" value={repo} onChange={this.handle_change} /></div>
        </div>
        <button onClick={(e) => this.update_config()} disabled={!is_config_complete(this.state)}>Save</button>
      </div>
    )
  }
}

const state_to_props = state => ({
  config: state.config,
})

export default connect(state_to_props, {update_config, load_pulls})(Config)
